import { gql } from "@apollo/client";

export const DELETE_INVOICE_ROWS = gql`
  mutation deleteInvoiceRows($input: DeleteInvoiceRowsInput!) {
    invoice {
      deleteInvoiceRows(input: $input) {
        success
      }
    }
  }
`;
